import { z } from 'zod';
import { errorWhenNull } from 'helpers/zod.helpers';

export const yearAndPeriodSchema = z.object({
  year: z.string({
    required_error: 'Please select a year',
    invalid_type_error: 'Please select a year'
  }),
  period: z.object(
    {
      startDate: z.string({
        required_error: 'Please select a period',
        invalid_type_error: 'Start date must be a string'
      }),
      endDate: z.string({
        required_error: 'Please select a period',
        invalid_type_error: 'End date must be a string'
      })
    },
    { errorMap: (_, ctx) => errorWhenNull(ctx, 'Please select a period') }
  )
});

export const dateRangeSchema = z.object({
  period: z.object(
    {
      startDate: z.string({
        required_error: 'Please select a start date',
        invalid_type_error: 'Please select a start date'
      }),
      endDate: z.string({
        required_error: 'Please select an end date',
        invalid_type_error: 'Please select an end date'
      })
    },
    { errorMap: (_, ctx) => errorWhenNull(ctx, 'Please select a date range') }
  )
});
